const JOIN_WITH = '[]';
const PLACEHOLDERS = [{char: '\n', placeholder: '_.'}];

export function parseMultiple(list: any[]): string[] {
  try {
    const translateMap = list.map(item => {
      const text = item[0];
      return text.trim();
    });

    let result = translateMap
      .join(' ')
      .split(` ${JOIN_WITH} `)
      .map(item => item.trim());

    result = result.map(text => {
      return safeDecodeURIComponent(text);
    });

    PLACEHOLDERS.forEach(({char, placeholder}) => {
      result = result.map(item => {
        if (typeof item === 'string') {
          return item.split(placeholder).join(char);
        }
        return '';
      });
    });

    return result;
  } catch (error) {
  }
  return [...list[0]];
}

const safeDecodeURIComponent = (str: string) => {
  try {
    return decodeURIComponent(str);
  } catch (error) {
    return str;
  }
};

export function arrayStringify(data: string[]): string {
  let encodedData = data.map((item: any) => {
    PLACEHOLDERS.forEach(({char, placeholder}) => {
      if (typeof item === 'string') {
        item = item.split(char).join(placeholder);
      } else if (Array.isArray(item) && item?.length > 0) {
        const text = item[0];
        if (typeof text === 'string') {
          return text;
        }
        return '---';
      }
      return '---';
    });
    return item;
  });

  return encodedData.join(` ${JOIN_WITH} `);
}
